export default __webpack_public_path__ + "static/media/snake_two.c239c8a7.png";